/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

declare global {
  const ngJitMode: boolean;
}

// Make this an ES module to be able to augment the global scope
export {};
